import { makeStyles } from "@material-ui/core";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { moveNextPage, updateCreatorOnboarding } from "../../../../../store/actions/creator/creatorOnBoarding";
import UtilService from "../../../../../helper/service";
import { useHistory, useLocation } from "react-router";
import OnboardingBtn from "../../../../atoms/creator/onboardingEnterBtn";

const useStyles = makeStyles(() => ({
  mainTitle: {
    fontSize: (props: any) => props.height < 770 ? 40 : 48,
    fontFamily: 'Spartan-bold',
    color: '#212D40',
    textAlign: 'center',
    marginTop: 10,
    marginBottom: 10,
    '@media (max-width: 600px)': {
      fontSize: '25px!important',
      marginTop: 0,
    },
  },
  titleDiv: {
    marginTop: 20,
    marginBottom: (props: any) => (props.height < 770) ? -30 : -20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  title: {
    textAlign: 'center',
    maxWidth: 909,
    lineHeight: 1.25,
    fontSize: (props: any) => (props.height < 770 || props.width < 1180) ? 20 : 24,
    color: '#212D40',
    fontFamily: 'roboto-light',
    '@media (max-width: 600px)': {
      fontSize: '15px!important',
    },
  },
  videoplayer: {
    width: '60vw',
    '@media (max-width: 600px)': {
      width: '80vw',
    },
  },
  boxcenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imgDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 600px)': {
      width: 400,
      height: 200
    },
    '@media (max-width: 400px)': {
      width: 320,
      height: 180
    },
  },
  img: {
    width: (props: any) => props.height < 770 ? 600 : 800,
    height: 'auto',
    '@media (max-width: 600px)': {
      width: 400,
      height: 200
    },
    '@media (max-width: 400px)': {
      width: 320,
      height: 180
    },
  }
}));

const Module1Slide1 = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { activepage } = userPreferences;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const size = UtilService.useWindowSize();
  const classes = useStyles(size);

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm1s1');
  }, []);

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13) {
      goNext();
    }
  };

  const goNext = () => {
    const request = {
      user_id: loginUserData.user_id,
      preference_id: userPreferences.module1s1.id,
      preference_name: 'MODULE1S1',
      preference_information: 'true',
    };
    dispatch(updateCreatorOnboarding(apolloClient.client, request));

    if (Number(activepage.value) < 3) {
      const reqActivePage = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activepage.id,
        preference_name: 'ACTIVEPAGE',
        preference_information: '3',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));
    }

    dispatch(moveNextPage(3))
  };

  const goBack = () => {
    dispatch(moveNextPage(1))
  };

  return (
    <div>
      <div className={classes.mainTitle}>
        Welcome to the first Module!
      </div>
      <div className={classes.boxcenter}>
      <video className={classes.videoplayer} autoPlay loop>
        <source src="/assets/video/immersion-screen-v3.mp4" type="video/mp4"/>
        <img className={classes.img} src={'/assets/icons/onboarding/module1-slide1.gif'} alt={'Video Playback Gif'} />
      </video>
      </div>
      <div className={classes.titleDiv}>
        <div className={classes.title}>
          Immersion shows you second-by-second how “immersed” or engaged your audience
          was during any experience, such as watching a video or attending a live event.
        </div>
      </div>
      <OnboardingBtn goNext={goNext} goBack={goBack} title={'Got It'} isRight />
    </div>
  )
};

export default Module1Slide1;